import { Component, Input, Output, ViewChild, ElementRef, EventEmitter, Renderer } from '@angular/core';

/**
 * Upload 
 * selector <upload-button></upload-button>
 * 
 * TODO 
 *  parametres, .. accept, ...
 *  drag&drop
 * 
 */
@Component({
  selector: 'upload-button',
  template: `<button ion-button (click)="callback($event)">
              {{btnText}}
               <ion-icon name="{{btnIcon}}"></ion-icon>
             </button>
             <input type="file" (change)="filesAdded($event)" style="display: none" accept=".txt" #input />`

})
              //  {{btnText}}

export class UploadButtonComponent {

  @Input()
  private btnText: String;

  @Input()
  private btnIcon: String;

  /**
   * The callback executed when files are selected, set by parent
   */
  @Input()
  private btnCallback: Function;

  /**
   * Native upload button (hidden)
   */
  @ViewChild("input")
  private nativeInputBtn: ElementRef;

  /**
   * Constructor
   * @param  {Renderer} renderer for invoking native methods
   */
  constructor(private renderer: Renderer) {}

  /**
   * Callback executed when the visible button is pressed
   * @param  {Event}  event should be a mouse click event
   */
  public callback(event: Event): void {

    // trigger click event of hidden input
    let clickEvent: MouseEvent = new MouseEvent("click", {bubbles: true});
    this.renderer.invokeElementMethod(
        this.nativeInputBtn.nativeElement, "dispatchEvent", [clickEvent]);
  }

  /**
   * Callback which is executed after files from native popup are selected.
   * @param  {Event}    event change event containing selected files
   */
  public filesAdded(event: Event): void {
    let files: FileList = this.nativeInputBtn.nativeElement.files;

    this.btnCallback(files);
  }
}


// http://pjsdev.blogspot.fr/2016/05/ionic-2-beta-6-angular-2-styled-upload.html




// export class FbstImgInputComponent {

// /*
//   TODO

//     imput imgPath 
//     Input icon non image, opacity ?
//     input icon animate loding opacity ?
    
    
//     permet de changer l'image, choix par fichier, par D&D, par choix camera, library
//     upload to server, avec mise en trash de l'ancienne, avec oid, et date
//     reprendre une image dans trash ?, undo ?
//     visuel sur upload progress dans l'image


//     permet de changer l'image actuelle
//       par D&D + visuel
//       par file select
//       par camera
//       par bibliotheque
//       dans cloud erased ?

//     Option remove background

//     dans catalog, ou MyFirebase, progresse bar service, afficher en haut ?
    


// */


//   // Path in bucket of the current image
//   @Input() imgPath: string;

//   @Output() imgPathChange : EventEmitter<string> = new EventEmitter<string>();

//   @Output() imgBase64Change : EventEmitter<string> = new EventEmitter<string>();

//  activeColor: string = 'green';
// baseColor: string = '#ccc';
// overlayColor: string = 'rgba(255,255,255,0.5)';
 

//   // @ViewChild('inputFile') inputFile: ElementRef;
//   @ViewChild('imgPreview') imgPreview: ElementRef;



//   myFirebase : MyFirebase;
//   fbSt : firebase.storage.Storage;


//   //
//   // Constructor
//   constructor() {

//     this.myFirebase = MyFirebase.get();    
//     this.fbSt = this.myFirebase.fbSt;

//     setTimeout( () => { 

//       this.getImgUrl(this.imgPath).then( (url) => { 
//         (<any>this.imgPreview.nativeElement).src = url;
//       }).catch( (error) => { 
// // TODO Log ?
// console.log('error ' + error);  
//       });
//     }, 1);
//   }






//   //
//   // Return the img url from img path
//   getImgUrl(imgPath : string) : Promise<any> {

//     try {
//       return null; //  this.myFirebase.getDownloadUrl(imgPath);
//     }catch(error) {
//       return Promise.reject(error);
//     }
//   }




// // http://embed.plnkr.co/mMVsbT/
// // https://openclassrooms.com/courses/dynamisez-vos-sites-web-avec-javascript/l-api-file

//  //
//   // End loading image
//   handleImageLoad() {
// console.log('handleImageLoad');    
//     // this.noImage = false;
//     // this.myDoCheck();
//   }

//   //
//   // Input File change
//   inputFileChange(e) {

//     let file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

//     let reader  = new FileReader();

//     reader.addEventListener("load", () => {

//       (<any>this.imgPreview.nativeElement).src = reader.result;

//       this.imgPathChange.next( file );
//       this.imgBase64Change.next( reader.result );

//     }, false);

//     if (file) {
//       reader.readAsDataURL(file);
//     }


//     // var pattern = /image-*/;
//     // if (!file.type.match(pattern)) {
//     //   alert('invalid format');
//     //   return;
//     // }

//     // //this.uploadFile();

//   }
  

   

//     dragging: boolean = false;
//     loaded: boolean = false;
//     imageLoaded: boolean = false;
//     imageSrc: string = '';
    
//     handleDragEnter() {
//       this.dragging = true;
//     }
    
//     handleDragLeave() {
//       this.dragging = false;
//     }
    
//     handleDrop(e) {
//       e.preventDefault();
//       this.dragging = false;
//       this.inputFileChange(e);
//     }
    

  
//     // handleInputChange(e) {
//     //     var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

//     //     var pattern = /image-*/;
//     //     var reader = new FileReader();

//     //     if (!file.type.match(pattern)) {
//     //         alert('invalid format');
//     //         return;
//     //     }

//     //     this.loaded = false;

//     //     reader.onload = this._handleReaderLoaded.bind(this);
//     //     reader.readAsDataURL(file);
//     // }
    
//     // _handleReaderLoaded(e) {
//     //     var reader = e.target;
//     //     this.imageSrc = reader.result;
//     //     this.loaded = true;
//     // }
    
//     // _setActive() {
//     //     this.borderColor = this.activeColor;
//     //     if (this.imageSrc.length === 0) {
//     //         this.iconColor = this.activeColor;
//     //     }
//     // }
    
//     // _setInactive() {
//     //     this.borderColor = this.baseColor;
//     //     if (this.imageSrc.length === 0) {
//     //         this.iconColor = this.baseColor;
//     //     }
//     // }
























//   // uploadFile()
//   // {
//   //   this.catalog.getAppData().uploadImage(this.file);
//   // }

//   // public base64Image: string;

//   // takePicture(){
//   //   Camera.getPicture({
//   //       destinationType: Camera.DestinationType.DATA_URL,
//   //       targetWidth: 500,
//   //       targetHeight: 500
//   //   }).then((imageData) => {
//   //     // imageData is a base64 encoded string
//   //       this.base64Image = "data:image/jpeg;base64," + imageData;
//   //   }, (err) => {
//   //       console.log(err);
//   //   });
//   // }


// }








// WEBPACK FOOTER //
// ./src/components/upload-button/upload-button.ts